var Handlebars = require("../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"0":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"pack-summary__item  "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"IsIncludedTypeGroup") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":36},"end":{"line":3,"column":85}}})) != null ? stack1 : "")
    + "\">\r\n      <div class=\"top\">\r\n        <div class=\"name\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"IsIncludedTypeGroup") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.program(3, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":6,"column":10},"end":{"line":10,"column":17}}})) != null ? stack1 : "")
    + "          <p class=\"name-text\">"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"GroupName") : depth0), depth0))
    + "</p>\r\n        </div>\r\n        \r\n"
    + ((stack1 = lookupProperty(helpers,"unless").call(alias1,(depth0 != null ? lookupProperty(depth0,"IsIncludedTypeGroup") : depth0),{"name":"unless","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":14,"column":8},"end":{"line":16,"column":19}}})) != null ? stack1 : "")
    + "      </div>\r\n      <div class=\"bottom\">\r\n        <ul>\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(alias1,(depth0 != null ? lookupProperty(depth0,"MatchingProducts") : depth0),{"name":"each","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":20,"column":10},"end":{"line":38,"column":19}}})) != null ? stack1 : "")
    + "        </ul>\r\n      </div>\r\n    </div>\r\n";
},"1":function(container,depth0,helpers,partials,data) {
    return " no-cursor";
},"2":function(container,depth0,helpers,partials,data) {
    return "              <img class=\"progress-icon\" src=\"/assets/images/pack-config/progress-star.svg\" alt=\"Progress Star Icon\">\r\n";
},"3":function(container,depth0,helpers,partials,data) {
    return "              <img class=\"progress-icon\" src=\"/assets/images/pack-config/progress-complete.svg\" alt=\"Progress Complete Icon\">\r\n";
},"4":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <button type=\"button\" class=\"edit-btn review-edit-btn\" data-groupid=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"GroupID") : depth0), depth0))
    + "\" data-productid=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"ProductID") : depth0), depth0))
    + "\" data-maxquantity=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"MaxQuantity") : depth0), depth0))
    + "\">"
    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"Labels") : depths[1])) != null ? lookupProperty(stack1,"Edit") : stack1), depth0))
    + " </button>        \r\n";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <li>\r\n              <div class=\"list-item\">\r\n                <div class=\"flavor-info\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"PackagingName") : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.program(7, data, 0),"data":data,"loc":{"start":{"line":24,"column":18},"end":{"line":28,"column":25}}})) != null ? stack1 : "")
    + "                </div>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"UpchargeAmount") : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":30,"column":16},"end":{"line":35,"column":23}}})) != null ? stack1 : "")
    + "              </div>\r\n            </li>\r\n";
},"6":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    <p>"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"ShortName") : depth0), depth0))
    + ", "
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"PackagingName") : depth0), depth0))
    + ", "
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"FlavorName") : depth0), depth0))
    + " - <span>QTY: "
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"Quantity") : depth0), depth0))
    + "</p>\r\n";
},"7":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    <p>"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"Name") : depth0), depth0))
    + " - <span>QTY: "
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"Quantity") : depth0), depth0))
    + "</p>\r\n";
},"8":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                  <div class=\"upcharge-wrapper\">\r\n                    <img src=\"/assets/images/pack-config/upcharge-icon.svg\" alt=\"Upcharge Icon\">\r\n                    "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"UpchargeDisplay") : depth0), depth0))
    + "\r\n                  </div>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"pack-summary\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"packData") : depth0),{"name":"each","hash":{},"fn":container.program(0, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":2},"end":{"line":42,"column":11}}})) != null ? stack1 : "")
    + "</div>";
},"useData":true,"useDepths":true});